import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UniverseComponent } from 'src/domains/common/universes';

export const Logotype = observer('Logotype', (): JSX.Element => {
    return <UniverseComponent>{(UniverseModule) => <UniverseModule.Logotype />}</UniverseComponent>;
});
